// /src/pages/parallel/ParallelEthnicityPage.js
import { useNavigate } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import { useState, useEffect } from "react";
import Header from "../../components/Header";
import "../../styles/ParallelEthnicityPage.css";

const fullEthnicGroups = [
  "African",
  "Any other Mixed / Multiple ethnic background",
  "Bangladeshi",
  "Caribbean",
  "Chinese",
  "Indian",
  "Pakistani",
  "White and Asian",
  "White and Black African",
  "White and Black Caribbean",
];

const mergedEthnicGroups = [
  "African",
  "Bangladeshi",
  "Caribbean",
  "Chinese",
  "Indian",
  "Pakistani",
];

const ParallelEthnicityPage = () => {
  const { setEthnicity } = useParallelPersona();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [displayedGroups, setDisplayedGroups] = useState(fullEthnicGroups);

  useEffect(() => {
    if (selectedOption === "merge") {
      setDisplayedGroups(mergedEthnicGroups);
    } else if (selectedOption === "no-merge") {
      setDisplayedGroups(fullEthnicGroups);
    }
  }, [selectedOption]);

  const handleNext = () => {
    setEthnicity(displayedGroups);
    navigate("/parallel/topics");
  };

  return (
    <div className="parallel-ethnicity-page">
      <Header />
      <h2 className="page-title">Select Ethnicity</h2>
      <p>The app found these ethnic groups in the dataset</p>
      <ol>
        {displayedGroups.map((group, index) => (
          <li key={index}>{group}</li>
        ))}
      </ol>
      <p>We suggest merging the following groups for better results:</p>
      <ul>
        <li>- Any other Mixed / Multiple ethnic background</li>
        <li>- White and Asian</li>
        <li>- White and Black African</li>
        <li>- White and Black Caribbean</li>
      </ul>
      <div className="ethnicity-options">
        <label>
          <input
            type="radio"
            name="ethnicity"
            value="merge"
            onChange={() => setSelectedOption("merge")}
          />{" "}
          Go ahead with merging above
        </label>
        <label>
          <input
            type="radio"
            name="ethnicity"
            value="no-merge"
            onChange={() => setSelectedOption("no-merge")}
          />{" "}
          Go ahead without merging
        </label>
      </div>
      <div className="navigation-buttons">
        <button
          className="back-button"
          onClick={() => navigate("/parallel/region")}
        >
          Back
        </button>
        <button
          className="next-button"
          onClick={handleNext}
          disabled={!selectedOption}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ParallelEthnicityPage;
